import clsx from "clsx"
import React from "react"
import { getIconColor } from "../../lib/utils"

const UserIconLogged = ({ className, color, isAuthenticated, ...props }) => {
  const stroke = getIconColor(color)

  return (
    <svg
    className={clsx("user-icon", className)}
    {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        fill={isAuthenticated ? stroke : "none"}
        d="M26.2499 10C26.2499 13.4518 23.4517 16.25 19.9999 16.25C16.5482 16.25 13.7499 13.4518 13.7499 10C13.7499 6.54822 16.5482 3.75 19.9999 3.75C23.4517 3.75 26.2499 6.54822 26.2499 10Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={isAuthenticated ? stroke : "none"}
        d="M7.50183 33.5304C7.61901 26.7282 13.1697 21.25 19.9999 21.25C26.8303 21.25 32.3811 26.7284 32.4981 33.5309C28.6934 35.2767 24.4606 36.25 20.0005 36.25C15.5399 36.25 11.3068 35.2765 7.50183 33.5304Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default UserIconLogged
